<template>
  <div id="app" class="app">
    <router-view />
    <notifications />
  </div>
</template>

<script>
import "@/style/app.scss";
import Notifications from "@/components/Notifications";
import { setPreferredTheme } from "@/utils/theme";
export default {
  components: { Notifications },
  mounted() {
    setPreferredTheme();
  }
};
</script>

<style scoped>
.app {
  position: relative;
  z-index: 0;
}
</style>
